import { render, staticRenderFns } from "./AllowanceSummaryReportTableRow.vue?vue&type=template&id=716a7fae"
import script from "./AllowanceSummaryReportTableRow.vue?vue&type=script&lang=js"
export * from "./AllowanceSummaryReportTableRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports